const images = require.context('../assets/images/otherMaterials', true);

export const contacts = [
  {
    id: 1,
    tel: '+38 044 209 53 02',
    title: 'international_number',
  },
  {
    id: 2,
    tel: '+38 098 683 85 21',
    title: 'number_kyivstar',
  },
  {
    id: 3,
    tel: '+38 098 306 84 84',
    title: 'number_kyivstar',
  },
  {
    id: 4,
    tel: '+38 063 499 37 69',
    title: 'number_life',
  },
];

export const actionList = [
  {
    id: 1,
    title: 'title',
    description: 'description',
    category: 'card_report',
    formRef: 'https://forms.gle/HS5mve4pupaqrXuc7',
  },
  {
    id: 2,
    title: 'title',
    description: 'description',
    category: 'card_register',
    formRef: 'https://forms.gle/5NvqFv9KnoqQnjTG9',
  },
  {
    id: 3,
    title: 'title',
    category: 'card_want',
    description: 'description',
    formRef: 'https://forms.gle/gBxn1smypqCXR8nJA',
  },
];

export const activities = [
  'gather',
  'print',
  'buy',
  'publishing',
  'exchange',
  'logistics',
  'accounting',
  'support',
  'provide',
  'help',
  'points',
  'support_army',
  'promote',
  'assistance',
];

export const mapPoints = [
  {
    id: 1,
    url: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2540.619404032457!2d30.437986815731186!3d50.44818947947503!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40d4cc2368662709%3A0x609e55c29c3b4020!2z0YPQuy4g0JDQu9C10LrRgdC10Y8g0KLQuNGF0L7Qs9C-LCA1NSwg0JrQuNC10LIsIDAyMDAw!5e0!3m2!1sru!2sua!4v1656661871443!5m2!1sru!2sua',
    street: 'вул. Олекси Тихого (Виборзька), буд. 55/13',
    city: 'Київ',
    country: 'Україна',
    service: 'прийом та видача',
    email: 'child.help.book@gmail.com',
    phones: ['+38 044 209 53 02', '+38 098 683 85 21', '+38 098 306 84 84', '+38 063 499 37 69'],
  },
];

export const otherMaterials = [
  {
    id: 0,
    imgSrc: images('./noBordersBooks-01.webp'),
    alt: 'Books without borders'
  },
  {
    id: 1,
    imgSrc: images('./noBordersBooks-02.webp'),
    alt: 'Books without borders'
  },
  {
    id: 2,
    imgSrc: images('./poster1.webp'),
    alt: 'Poster about book collection points'
  },
  {
    id: 3,
    imgSrc: images('./poster2.webp'),
    alt: 'Poster about book collection points'
  },
  {
    id: 4,
    imgSrc: images('./poster3.webp'),
    alt: 'Poster about book collection points'
  },
  {
    id: 5,
    imgSrc: images('./toCulture-01.webp'),
    alt: 'Letter from the Department of Culture'
  },
  {
    id: 6,
    imgSrc: images('./toCulture-02.webp'),
    alt: 'Letter from the Department of Culture'
  },
];
